import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Benefits } from "../components/Benefits";
import { Process } from "../components/Process";
import { Earnings } from "../components/Earnings";
import { FAQ } from "../components/FAQ";
import { CTAFooter } from "../components/CTAFooter";

const PHONE = "+1 (742) 688-6642";
const WHATSAPP = "+17426886642";
const EMAIL = "hello@knockwavetelecom.com";

export default function Landing() {
  return (
    <div className="min-h-screen bg-slate-50 antialiased" data-testid="landing-page">
      <Header phone={PHONE} />
      <main>
        <Hero phone={PHONE} whatsapp={WHATSAPP} />
        <Benefits />
        <Process />
        <Earnings phone={PHONE} whatsapp={WHATSAPP} />
        <FAQ />
      </main>
      <CTAFooter phone={PHONE} whatsapp={WHATSAPP} email={EMAIL} />
    </div>
  );
}
